import N from "./objectWithoutPropertiesLoose3.mjs";
import R from "./extends3.mjs";
import * as s from "react";
import { getPickersPopperUtilityClass as X } from "./pickersPopperClasses.mjs";
import { getActiveElement as B } from "./utils7.mjs";
import { useDefaultReduceAnimations as G } from "./useDefaultReduceAnimations.mjs";
import { jsx as T } from "react/jsx-runtime";
import _ from "./styled.mjs";
import Y from "./Popper.mjs";
import q from "./Paper.mjs";
import J from "./useThemeProps.mjs";
import A from "./useForkRef.mjs";
import Q from "./Fade.mjs";
import V from "./Grow.mjs";
import { FocusTrap as Z } from "./FocusTrap.mjs";
import { useSlotProps as x } from "./useSlotProps.mjs";
import ee from "./composeClasses.mjs";
import te from "./useEventCallback.mjs";
import w from "./ownerDocument.mjs";
const oe = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], re = (t) => {
  const {
    classes: o
  } = t;
  return ee({
    root: ["root"],
    paper: ["paper"]
  }, X, o);
}, ne = _(Y, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (t, o) => o.root
})(({
  theme: t
}) => ({
  zIndex: t.zIndex.modal
})), se = _(q, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (t, o) => o.paper
})(({
  ownerState: t
}) => R({
  outline: 0,
  transformOrigin: "top center"
}, t.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function ce(t, o) {
  return o.documentElement.clientWidth < t.clientX || o.documentElement.clientHeight < t.clientY;
}
function pe(t, o) {
  const p = s.useRef(!1), u = s.useRef(!1), n = s.useRef(null), d = s.useRef(!1);
  s.useEffect(() => {
    if (!t)
      return;
    function e() {
      d.current = !0;
    }
    return document.addEventListener("mousedown", e, !0), document.addEventListener("touchstart", e, !0), () => {
      document.removeEventListener("mousedown", e, !0), document.removeEventListener("touchstart", e, !0), d.current = !1;
    };
  }, [t]);
  const i = te((e) => {
    if (!d.current)
      return;
    const l = u.current;
    u.current = !1;
    const P = w(n.current);
    if (!n.current || // is a TouchEvent?
    "clientX" in e && ce(e, P))
      return;
    if (p.current) {
      p.current = !1;
      return;
    }
    let c;
    e.composedPath ? c = e.composedPath().indexOf(n.current) > -1 : c = !P.documentElement.contains(e.target) || n.current.contains(e.target), !c && !l && o(e);
  }), E = () => {
    u.current = !0;
  };
  return s.useEffect(() => {
    if (t) {
      const e = w(n.current), l = () => {
        p.current = !0;
      };
      return e.addEventListener("touchstart", i), e.addEventListener("touchmove", l), () => {
        e.removeEventListener("touchstart", i), e.removeEventListener("touchmove", l);
      };
    }
  }, [t, i]), s.useEffect(() => {
    if (t) {
      const e = w(n.current);
      return e.addEventListener("click", i), () => {
        e.removeEventListener("click", i), u.current = !1;
      };
    }
  }, [t, i]), [n, E, E];
}
const ie = /* @__PURE__ */ s.forwardRef((t, o) => {
  const {
    PaperComponent: p,
    popperPlacement: u,
    ownerState: n,
    children: d,
    paperSlotProps: i,
    paperClasses: E,
    onPaperClick: e,
    onPaperTouchStart: l
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = t, P = N(t, oe), c = R({}, n, {
    placement: u
  }), r = x({
    elementType: p,
    externalSlotProps: i,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: o
    },
    className: E,
    ownerState: c
  });
  return /* @__PURE__ */ T(p, R({}, P, r, {
    onClick: (a) => {
      var h;
      e(a), (h = r.onClick) == null || h.call(r, a);
    },
    onTouchStart: (a) => {
      var h;
      l(a), (h = r.onTouchStart) == null || h.call(r, a);
    },
    ownerState: c,
    children: d
  }));
});
function Fe(t) {
  var o, p, u, n;
  const d = J({
    props: t,
    name: "MuiPickersPopper"
  }), {
    anchorEl: i,
    children: E,
    containerRef: e = null,
    shouldRestoreFocus: l,
    onBlur: P,
    onDismiss: c,
    open: r,
    role: a,
    placement: h,
    slots: m,
    slotProps: f,
    reduceAnimations: C
  } = d;
  s.useEffect(() => {
    function k(S) {
      r && (S.key === "Escape" || S.key === "Esc") && c();
    }
    return document.addEventListener("keydown", k), () => {
      document.removeEventListener("keydown", k);
    };
  }, [c, r]);
  const v = s.useRef(null);
  s.useEffect(() => {
    a === "tooltip" || l && !l() || (r ? v.current = B(document) : v.current && v.current instanceof HTMLElement && setTimeout(() => {
      v.current instanceof HTMLElement && v.current.focus();
    }));
  }, [r, a, l]);
  const [b, g, M] = pe(r, P ?? c), D = s.useRef(null), $ = A(D, e), O = A($, b), y = d, L = re(y), I = G(), H = C ?? I, K = (k) => {
    k.key === "Escape" && (k.stopPropagation(), c());
  }, U = ((o = m?.desktopTransition) != null ? o : H) ? Q : V, W = (p = m?.desktopTrapFocus) != null ? p : Z, j = (u = m?.desktopPaper) != null ? u : se, F = (n = m?.popper) != null ? n : ne, z = x({
    elementType: F,
    externalSlotProps: f?.popper,
    additionalProps: {
      transition: !0,
      role: a,
      open: r,
      anchorEl: i,
      placement: h,
      onKeyDown: K
    },
    className: L.root,
    ownerState: d
  });
  return /* @__PURE__ */ T(F, R({}, z, {
    children: ({
      TransitionProps: k,
      placement: S
    }) => /* @__PURE__ */ T(W, R({
      open: r,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: a === "tooltip",
      isEnabled: () => !0
    }, f?.desktopTrapFocus, {
      children: /* @__PURE__ */ T(U, R({}, k, f?.desktopTransition, {
        children: /* @__PURE__ */ T(ie, {
          PaperComponent: j,
          ownerState: y,
          popperPlacement: S,
          ref: O,
          onPaperClick: g,
          onPaperTouchStart: M,
          paperClasses: L.paper,
          paperSlotProps: f?.desktopPaper,
          children: E
        })
      }))
    }))
  }));
}
export {
  Fe as PickersPopper
};
//# sourceMappingURL=PickersPopper.mjs.map
